import type { Session } from '@supabase/supabase-js';

export const useSupabaseSession = (): Ref<Omit<Session, 'user'> | null> => useState<Omit<Session, 'user'> | null>('supabase_session', () => null);
